import { TicketSellableThrough as GqlChannel } from '../../../generated/api.graphql';

/** A channel a ticket sells through; wrapped because `@vp/admin` cannot import generated types. */
export const TicketSellableThrough = Object.freeze({
  ONLINE: GqlChannel.Online,
  BOX_OFFICE: GqlChannel.BoxOffice,
});
export type TicketSellableThrough = (typeof TicketSellableThrough)[keyof typeof TicketSellableThrough];
